import React from "react";
import "../../../index.css";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import "./home.css";
import {getCards} from "../HomeCards";

function Home(props) {


    return (
        <React.Fragment>
            <div className="home">
                <div className={"home_title"}>
                    <Typography variant={"h4"}>Welcome to GPAP Data Submission & Management App </Typography>
                    <Typography variant={"h5"}> Submit, Browse and share experiments of rare
                        disease patients</Typography>
                </div>
                <Typography variant={"h4"}>Where you can start from</Typography>
                <div className="boxStart">
                    <Grid container justifyContent="center" spacing={2}>
                        {getCards()}
                    </Grid>
                </div>


            </div>


        </React.Fragment>
    );
}

export default Home;
